import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import AdminUsersMobile from '../IdentityAdmin/AdminUsersMobile'
import AdminUsers from '../IdentityAdmin/AdminUsers'
const AdminUserWrapper:React.FC = () => {
    const isMobile = useMobileContext()
    return isMobile ? <AdminUsersMobile /> : <AdminUsers />
}
export default AdminUserWrapper